import { BasePublicApi } from '#packages/apilib';
import { browserUtil } from '#packages/util';
import { isPasteTargetAllowed } from '#packages/util';
import experiment from 'experiment';
import { readFromNativeClipboard } from '#packages/clipboard';

import type { PasteClipboardDataToStageScope } from './pasteClipboardDataToStageEntryPoint';

let pasteFunctionToCall: () => void = () => {};

const setPasteFunctionToCall = (fn: () => void) => {
  pasteFunctionToCall = fn;
};

export const bootstrap = ({
  pasteHandlers,
}: PasteClipboardDataToStageScope) => {
  document.addEventListener('paste', async function (event: ClipboardEvent) {
    if (experiment.isOpen('se_nativeClipboard')) {
      readFromNativeClipboard(event);
    }

    let dataPasted = false;

    if (browserUtil.isFirefox()) {
      pasteFunctionToCall();
      return;
    }

    if (!isPasteTargetAllowed(event)) {
      return;
    }

    pasteHandlers.forEach((handler) => {
      if (handler.validate && handler.handleUpload && handler.validate(event)) {
        handler.handleUpload(event);
        dataPasted = true;
      }
    });

    if (!dataPasted) {
      pasteFunctionToCall();
    }
  });
};

export class PasteClipboardDataToStageApi extends BasePublicApi<PasteClipboardDataToStageScope> {
  setPasteFunctionToCall = setPasteFunctionToCall;
}
